export default __webpack_public_path__ + "static/tt-norms-pro-medium-fbd1d790900dcd2d3d5bf59a9006d330.woff2";